export default __webpack_public_path__ + "static/Leaf8-d2417e7c5403c6e3bcc8245e055033d9.png";